import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { breakpoints, useWindowWidth } from '@awaze/design-system.utils.react';
import { useEffect, useState } from 'react';
import { StyledBannerContainer, StyledCountdownContainer, StyledCountdownText, StyledNumbers, StyledSaleName, StyledSubText, StyledTextContainer, StyledTimeContainer, } from './countdown-banner.styles';
/**
 * TODO: Description to be provided by component owner.
 */
export const CountdownBanner = ({ endDate, timeLabelText, primaryTextDefault, primaryTextMobile, secondaryTextDefault, secondaryTextMobile, startDate = new Date(), shouldHideOnEnd = true, variant = 'primary', styleOverrides, }) => {
    const timeInSeconds = {
        day: 60 * 60 * 24,
        hour: 60 * 60,
        minute: 60,
    };
    let timeUntilStart = startDate.getTime() - Date.now();
    let hasReachedStartDate = timeUntilStart <= 0;
    let differenceInSeconds = Math.floor((endDate.getTime() - Date.now()) / 1000);
    const [shouldUnmount, setShouldUnmount] = useState(differenceInSeconds < 0);
    const [shouldDisplay, setShouldDisplay] = useState(differenceInSeconds > 0 && hasReachedStartDate);
    const [remainingTime, setRemainingTime] = useState({
        days: '--',
        hours: '--',
        minutes: '--',
        seconds: '--',
    });
    useEffect(() => {
        const interval = setInterval(async () => {
            if (!hasReachedStartDate) {
                timeUntilStart -= 1000;
                if (timeUntilStart <= 0) {
                    hasReachedStartDate = true;
                    setShouldDisplay(differenceInSeconds > 0 && hasReachedStartDate);
                }
            }
            setRemainingTime({
                days: Math.floor(differenceInSeconds / timeInSeconds.day),
                hours: Math.floor((differenceInSeconds % timeInSeconds.day) / timeInSeconds.hour),
                minutes: Math.floor((differenceInSeconds % timeInSeconds.hour) / timeInSeconds.minute),
                seconds: differenceInSeconds % 60,
            });
            if (differenceInSeconds > 0) {
                differenceInSeconds -= 1;
            }
            else if (shouldHideOnEnd) {
                clearInterval(interval);
                setShouldDisplay(false);
                const unmountTransitionTime = 2000;
                await new Promise((resolve) => setTimeout(resolve, unmountTransitionTime));
                setShouldUnmount(true);
            }
            else {
                clearInterval(interval);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    const formatTime = (time) => String(time).padStart(2, '0');
    const timeLabels = [
        { label: 'days', value: remainingTime.days },
        { label: 'hours', value: remainingTime.hours },
        { label: 'minutes', value: remainingTime.minutes },
        { label: 'seconds', value: remainingTime.seconds },
    ];
    const windowWidth = useWindowWidth();
    const isDesktop = windowWidth > breakpoints[0];
    return shouldUnmount ? (_jsx(_Fragment, {})) : (_jsxs(StyledBannerContainer, { variant: variant, styleOverrides: styleOverrides, className: shouldDisplay ? '' : 'unmounted', children: [_jsxs(StyledTextContainer, { children: [_jsx(StyledSaleName, { children: isDesktop ? primaryTextDefault : primaryTextMobile }), _jsx(StyledSubText, { children: isDesktop ? secondaryTextDefault : secondaryTextMobile })] }), _jsx(StyledCountdownContainer, { children: timeLabels.map(({ label, value }) => (_jsxs(StyledTimeContainer, { children: [_jsx(StyledNumbers, { children: formatTime(value) }), _jsx(StyledCountdownText, { children: timeLabelText[label] })] }, label))) })] }));
};
//# sourceMappingURL=countdown-banner.js.map